import { Point } from "highcharts";
import { HighChartDataSeriesMapType } from "@/storybook/c8r-highcharts/common/utils/helpers/aggregateHighChartDataSeriesMap";
import { ResourceExplorerChartDataSeriesTotalCostsMapType } from "@/store/resource-explorer/utils/helpers/chart/aggregateResourceExplorerChartDataSeriesTotalCostsMap";
import { generateBillingExplorerChartTooltipMarkup } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-chart/utils/helpers/tooltip/generateBillingExplorerChartTooltipMarkup";
import { chartCumulativeSeriesName } from "@/storybook/c8r-highcharts/common/utils/constants/chartDefaultConfigs";
import { generateBillingExplorerChartCumulativeTooltipMarkup } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-chart/utils/helpers/tooltip/generateBillingExplorerChartCumulativeTooltipMarkup";
import { HighchartsChartDataType } from "@/storybook/c8r-highcharts/common/utils/types/common";

export const getBillingExplorerWidgetTooltipValueFormatter = (
  chartDataCostBasedMap?: HighChartDataSeriesMapType,
  chartDataPercentBasedMap?: HighChartDataSeriesMapType,
  totalCostsMap?: ResourceExplorerChartDataSeriesTotalCostsMapType,
  chartData?: HighchartsChartDataType | null,
) => {
  return (point: Point) => {
    const total = totalCostsMap?.get(point.index.toString()) ?? 0;

    const isCumulative =
      point.series.type === "line" &&
      point.series.name.startsWith(chartCumulativeSeriesName);

    if (isCumulative) {
      return generateBillingExplorerChartCumulativeTooltipMarkup(
        total,
        point?.y ?? 0,
        chartData?.categories?.at(0) ?? "",
        chartData?.categories?.at(point.index) ?? "",
      );
    }

    const costBasedData = chartDataCostBasedMap?.get(point.series.name)?.data;
    const percentBasedData = chartDataPercentBasedMap?.get(
      point.series.name,
    )?.data;

    const value = costBasedData?.[point.index]?.y ?? 0;
    const percent = percentBasedData?.[point.index]?.y ?? 0;

    return generateBillingExplorerChartTooltipMarkup(
      `${point.category}`,
      point.series.name,
      `${point.color}`,
      value,
      percent,
      total,
    );
  };
};
